import React, { useCallback } from "react";
import { Survey } from "survey-react-ui";
import { StylesManager, Model, surveyLocalization } from "survey-core";
import "survey-core/defaultV2.css";
import elements from "./SurveyElement";
import { DefaultLight } from "survey-core/themes";
StylesManager.applyTheme("defaultV2");
const localeString = {
  pagePrevText: "이전",
  pageNextText: "다음",
  completeText: "제출하기",
};
surveyLocalization.locales.my = localeString;
const Interview = () => {
  const surveyComplete = useCallback(sender => {
    const result = sender.data;

    const phone = result.user_phone.replace(/[^0-9]/g, "");
    delete result.user_phone;
    const keys = Object.keys(result);

    const data = {
      survey_id: 3,
      phone_no: phone,
      answer: keys.map(key => ({
        question_id: key,
        answer: Array.isArray(result[key]) ? result[key].join() : result[key],
      })),
    };

    fetch("https://senor.co.kr/surveyAnswer", {
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(data),
    });
  }, []);
  const survey = new Model(elements);
  survey.applyTheme({
    ...DefaultLight,
    cssVariables: {
      ...DefaultLight.cssVariables,
      "--sjs-primary-backcolor": "rgba(0,0,0,0.8)",
      "--sjs-general-forecolor": "rgba(0, 0, 0, 0.91)",
      "--sjs-general-forecolor-light": "rgba(0, 0, 0, 0.45)",
      "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
      "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",
    },
  });
  survey.onComplete.add(surveyComplete);
  survey.locale = "my";
  return <Survey model={survey} />;
};

export default Interview;
